module.exports = __webpack_public_path__ + "static/img/18012C_1_2_C_20210606_fit.342d3b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18012C_1_2_C_20210606_fit.png
// module id = o/qx
// module chunks = 0